// O tipo da movimentação vem da aba de consulta que originou a lista
// ('novo' = patrimoniosnfs, senão inventário/patrimonios). Nunca inferir
// por campos do registro: NFS com produto NULL existe (2k+ no banco) e a
// heurística antiga mandava o update para a tabela errada.
const tipoMovimentacao = (patrimonioType) => (patrimonioType === 'novo' ? 'NFS' : 'inventario');

export default tipoMovimentacao;
